export default "__VITE_ASSET__CzGTOofN__"